import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=75619ef6"
import script from "./GroupsTable.vue?vue&type=script&lang=js"
export * from "./GroupsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=75619ef6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports